import PropTypes from "prop-types";
import { createContext, useContext } from "react";
import useRecommendedActionsUserSettings from "../hooks/use-recommended-action-user-settings";

const RecommendedActionsContext = createContext(() => {});

const RecommendedActionsProvider = ({ children }) => {
  const userSettingsState = useRecommendedActionsUserSettings();

  return (
    <RecommendedActionsContext.Provider value={{ ...userSettingsState }}>{children}</RecommendedActionsContext.Provider>
  );
};

RecommendedActionsProvider.propTypes = {
  children: PropTypes.any,
};

const useRecommendedActionsProvider = () => {
  const context = useContext(RecommendedActionsContext);

  if (!context) {
    throw new Error("useRecommendedActionsProvider must be used within a RecommendedActionsProvider");
  }

  return context;
};

export { RecommendedActionsProvider, RecommendedActionsContext, useRecommendedActionsProvider };
